unit Essentials.Web.Shared;

interface

uses
  System.SysUtils,
  System.Generics.Collections,
  Essentials.Web.Manager;

type
  TEditMode = (None, Add, Edit);

function GetToggleMode(Value: TEditMode; const TheReference: TEditMode): TEditMode;
function EssentialsManager: TEssentialsManager;

implementation

var
  FEssentialsManager: TEssentialsManager;

function EssentialsManager: TEssentialsManager;
begin
  if not Assigned(FEssentialsManager) then
    FEssentialsManager := TEssentialsManager.Create;
  result := FEssentialsManager;
end;

function GetToggleMode(Value: TEditMode; const TheReference: TEditMode): TEditMode;
begin
  if TheReference = Value then
    Result := None
  else
    Result := Value;
end;

end.

